<template>
  <v-img>
    <template #placeholder>
      <div class="d-flex align-center justify-center fill-height">
        <img src="@/assets/imgs/common/loading.gif" />
      </div>
    </template>
    <template v-for="(_, name) in $slots">
      <slot :name="name" />
    </template>
  </v-img>
</template>
